import { useQuery } from '@tanstack/react-query';
import { portalDb, type PortalJobRow } from './portalClient';

export function usePortalJobs(companyId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'jobs'],
    enabled: !!companyId,
    staleTime: 60_000,
    queryFn: async (): Promise<PortalJobRow[]> => {
      const { data, error } = await portalDb
        .from('portal_jobs')
        .select('*')
        .eq('company_id', companyId)
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as PortalJobRow[];
    },
  });
}

export function usePortalJob(companyId: string | undefined, jobId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'jobs', jobId],
    enabled: !!companyId && !!jobId,
    staleTime: 60_000,
    queryFn: async (): Promise<PortalJobRow | null> => {
      const { data, error } = await portalDb
        .from('portal_jobs')
        .select('*')
        .eq('company_id', companyId)
        .eq('id', jobId)
        .maybeSingle();
      if (error) throw error;
      return (data as PortalJobRow | null) ?? null;
    },
  });
}
